<template>
  <CommonTabs
    :id="$props.id"
    resource="manage-records"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'meter-units' }"
    :breadcrumbs="breadcrumbs"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../../../components/common/tabs/CommonTabs";
import MeterRecord from "../../../components/projects/metering/manage-record/MeterRecord";
import ReprocessTransmissions from "../../../components/projects/metering/manage-record/ReprocessTransmissions";
import DeleteRecords from "../../../components/projects/metering/manage-record/DeleteRecords";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
export default {
  name: "ManageRecord",
  mixins: [projectTitle],
  components: {
    CommonTabs
  },
  props: ["project_id", "id"],
  data: () => ({
    components: {
      MeterRecord,
      ReprocessTransmissions,
      DeleteRecords
    }
  }),
  computed: {
    reprocessTransmissionsTab() {
      let meterUnit = this.$store.getters[
        "projectMeteringStore/meterUnitStore/getItem"
      ];
      if (meterUnit && meterUnit.source_id) {
        return [
          {
            component: "ReprocessTransmissions",
            title: "reprocess-transmissions"
          }
        ];
      }
      return [];
    },
    tabs() {
      return [
        {
          component: "MeterRecord",
          title: "meter-record"
        },
        ...this.reprocessTransmissionsTab,
        {
          component: "DeleteRecords",
          title: "delete-records"
        }
      ];
    },
    meterUnit: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/meterUnitStore/getItem"
        ];
      }
    },
    breadcrumbs() {
      return this.meterUnit.id
        ? [
            {
              text: this.$t("meter-units.meter-units"),
              to: {
                name: "meter-units",
                params: {
                  project_id: this.project.id
                }
              },
              exact: true
            },
            {
              text: this.meterUnit.name,
              to: {
                name: "meter-unit",
                params: {
                  project_id: this.project.id,
                  id: this.meterUnit.id
                }
              },
              exact: true
            }
          ]
        : [];
    }
  },
  watch: {
    meterUnit: function() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("meter-units.meter-units"),
          this.meterUnit.name,
          this.$t("manage-records.manage-records")
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("projectMeteringStore/meterUnitStore/get", {
      id: this.$route.params.id,
      params: {
        project_id: this.$route.params.project_id
      }
    });
  }
};
</script>

<style scoped></style>
